import { keepPreviousData, queryOptions, useQuery } from "@tanstack/react-query"
import { GET, type Schema } from "@/api/client"

export type GasStorageComparisonResponse =
	Schema["GasStorageComparisonResponse"]
export type GasStorageYearData = Schema["GasStorageYearData"]

export function gasStorageChartOptions(year: number) {
	return queryOptions({
		queryKey: ["market-data", "gas-storage", "chart", year],
		queryFn: () =>
			GET("/api/v1/market-data/gas-storage/chart/{year}", {
				params: { path: { year } },
			}),
		placeholderData: keepPreviousData,
	})
}

export function useGasStorageChart(year: number) {
	return useQuery(gasStorageChartOptions(year))
}

export function gasStorageYearsOptions() {
	return queryOptions({
		queryKey: ["market-data", "gas-storage", "years"],
		queryFn: () => GET("/api/v1/market-data/gas-storage/years"),
	})
}

export function useGasStorageYears() {
	return useQuery(gasStorageYearsOptions())
}
